import { useForm } from "@inertiajs/react";
import { accountPayoutsPath } from "@travily/routes";
import type { ReactNode } from "react";
import { useCallback, useRef } from "react";
import { RoutedModal } from "@/components/RoutedModal";
import { firstError } from "@/lib/forms/first-error";
import { PayoutsCountryModal } from "./new.view";

interface AccountPayoutsNewProps {
  supported_countries: Array<{ code: string; name: string }>;
  default_country: string | null;
}

const AccountPayoutsNewPage = ({ supported_countries, default_country }: AccountPayoutsNewProps) => {
  const form = useForm({
    country: default_country ?? "",
  });

  const formRef = useRef(form);
  formRef.current = form;

  const handleCountryChange = useCallback((code: string) => {
    formRef.current.setData("country", code);
  }, []);

  const handleSubmit = useCallback(() => {
    formRef.current.post(accountPayoutsPath());
  }, []);

  return (
    <RoutedModal size="sm">
      {({ close }) => (
        <PayoutsCountryModal
          close={close}
          supportedCountries={supported_countries}
          country={form.data.country}
          onCountryChange={handleCountryChange}
          error={firstError(form.errors.country)}
          onSubmit={handleSubmit}
          isPending={form.processing}
        />
      )}
    </RoutedModal>
  );
};

AccountPayoutsNewPage.layout = (page: ReactNode) => page;

export default AccountPayoutsNewPage;
